import React from "react";
import Head from "next/head";
import { DefaultSeo, NextSeo } from "next-seo";
import type { NextSeoProps } from "next-seo/lib/types";

import { domainName } from "@src/utils/urlUtils";

export const PageHead: React.FunctionComponent<{ pageSeo?: NextSeoProps }> = ({ pageSeo }) => {
  return (
    <>
      <Head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width, shrink-to-fit=no" />
      </Head>

      <DefaultSeo
        titleTemplate="%s | KĀDI Console"
        defaultTitle="KĀDI Console"
        description="KĀDI Console — deploy Docker containers to the KĀDI Network with your own wallet."
        openGraph={{
          type: "website",
          locale: "en_US",
          url: `${domainName}/`,
          site_name: "KĀDI Console",
          description: "Deploy docker containers on the KĀDI Network."
        }}
      />

      <NextSeo {...pageSeo} />
    </>
  );
};
